<div class="col-12 col-lg-auto mb-20">
  <div class="user-layout-heading">
    <h3 class="current-path">
      <a routerLink="/home">
        <i class="fa fa-arrow-left" *ngIf="isInHome()"></i>
        Home
      </a>
      <span>{{getSubPath()}}</span>
    </h3>
  </div>
</div>
